import { DateTime } from 'luxon';

import { IPatient, IOnDemand, v2, constants } from '../../..';
import { contactRecordAdapter } from '.';
import { getDefaults } from './helpers/getDefaults';
import { getGenderName } from './helpers/getGenderName';
import { getLanguageMapping } from './helpers/getLanguageMapping';

export const personAdapter = (patient: IPatient): v2.Person => {
    const {
        middleName,
        dateOfBirth: dateOfBirthString,
        languagesSpoken,
        age,
    } = patient as IOnDemand; // Need to cast this to IOnDemand to access the age property

    const defaults = getDefaults(patient);
    const firstName = patient.firstName ? patient.firstName : '';
    const lastName = patient.lastName ? patient.lastName : '';
    const gender = patient.gender ? getGenderName(patient.gender) : '';

    let languagesFluent: v2.TLanguageType[] | undefined;

    if (languagesSpoken?.length) {
        languagesFluent = languagesSpoken.flatMap((language) => {
            const mappedLanguage = getLanguageMapping(language);
            return mappedLanguage ? [mappedLanguage] : [];
        });
    }

    let dateOfBirth: Date | undefined;

    if (dateOfBirthString) {
        dateOfBirth = new Date(dateOfBirthString);
    } else if (age) {
        dateOfBirth = DateTime.utc().minus({ years: age }).toJSDate();
    }

    return {
        ...defaults,
        id: constants.NOT_CAPTURED,
        firstName,
        lastName,
        middleName,
        languagesFluent,
        contactRecords: contactRecordAdapter(patient),
        dateOfBirth: dateOfBirth ? new Date(dateOfBirth) : undefined,
        genderId: gender,
        gender: {
            ...defaults,
            id: constants.NOT_CAPTURED,
            name: gender,
        },
    };
};
